/** All marketing / home shell routes — defer third-party scripts on first paint (guest + logged-in). */
/** Keep vanity paths in sync with CAMPAIGN_LANDING_SOURCES in utm-tracking.tsx */
const HOME_LANDING_EXACT = new Set([
  '/',
  '/home',
  '/home/client',
  '/home/consultant',
  '/home/career',
  '/home/marketing',
  '/home/itconsultant',
  '/client-home',
  '/consultant-home',
  '/career-home',
  '/marketing-home',
  '/it-home',
  '/linkedin',
  '/instagram',
  '/jobboard',
  '/utm',
  '/login',
  '/signup',
]);

const HOME_LANDING_PREFIXES = [
  '/home/client/',
  '/home/consultant/',
  '/home/career/',
  '/home/marketing/',
  '/home/itconsultant/',
  '/utm/',
];

const normalizePath = (pathname: string): string => {
  const path = (pathname || '/').split('?')[0] || '/';
  return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
};

export function isHomeLandingPath(pathname: string): boolean {
  const normalized = normalizePath(pathname);

  if (HOME_LANDING_EXACT.has(normalized)) {
    return true;
  }

  return HOME_LANDING_PREFIXES.some(
    (prefix) => normalized === prefix.slice(0, -1) || normalized.startsWith(prefix)
  );
}

/** New landing routes with static hero HTML in index.html */
const HOME_STATIC_HERO_EXACT = new Set([
  '/home',
  '/home/client',
  '/home/consultant',
  '/client-home',
  '/consultant-home',
]);

export function isHomeStaticHeroPath(pathname: string): boolean {
  return HOME_STATIC_HERO_EXACT.has(normalizePath(pathname));
}

/** @deprecated Use isHomeLandingPath — kept for imports that meant guest marketing only */
export const isPublicMarketingPath = isHomeLandingPath;
